module.exports = __webpack_public_path__ + "img/gafanov.f894b002.jpg";